import "./Header.scss";
import BottomHeader from "./BottomHeader";
import PageContext from "pages/PageContext";
import TopHeader from "./TopHeader";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";

const Header = () => {
  const location = useLocation();
  const navigation = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const isExport = queryParams.get("export") === "true";

  const { lang, user, userScope, userSetLang, userSetScope } =
    useContext(PageContext);

  const changeLanguage = (langChosen) => {
    if (lang !== langChosen) {
      userSetLang(langChosen);
    }
  };

  const changeUserScope = (scope) => {
    let params = location.pathname.split("/").filter((e) => e && e.length > 0);
    if (params.length === 0) {
      params = [scope];
    } else {
      params[0] = scope;
    }
    const newPath = `/${params.join("/")}`;
    return navigation(newPath);
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (userScope) {
      changeUserScope(userScope);
    }
  }, [userScope]);

  const navigate = (path) => {
    if (typeof path === "string") {
      const finalPath = ["/login", "/logout"].includes(path)
        ? path
        : `/${userScope}/${path}`;
      return navigation(finalPath);
    } else {
      const pathByScope = path.find((elm) =>
        elm.split("/").find((e) => e === userScope)
      );
      if (!pathByScope) return;
      return navigation(pathByScope);
    }
  };

  const isLangActive = (currentLang) => {
    return lang === currentLang ? "active" : "";
  };
  if (isExport) {
    return null;
  }
  return (
    <div className="header-container">
      <TopHeader
        changeLanguage={changeLanguage}
        changeUserScope={userSetScope}
        currentUserScope={userScope}
        navigate={navigate}
        isLangActive={isLangActive}
        getFullUsername={user?.full_name}
      />
      <div className="separator"></div>
      <BottomHeader navigate={navigate} />
    </div>
  );
};

export default Header;
